import { t } from '@/i18n/utils'

/**
 * Home 页面公共配置
 * 所有品牌共享的文案
 */

export const homeCommonConfig = {
  texts: {
    get searchPlaceholder() { return t('SearchBox') },
    get seeAll() { return t('SeeAll') },
    get loading() { return `${t('Loading')}...` },
    get noMore() { return `${t('NoMore')} ~` },
  },
}

/**
 * 逍遥联动配置
 * 只在指定域名下显示逍遥图标
 */
export const xiaoyaoConfig = {
  // 允许显示逍遥图标的域名列表
  allowedDomains: [
    'book-test.oceread.com',
    'xiaoyao-book.oceread.com',
    'localhost:3000',
  ],
}
